import { render, staticRenderFns } from "./tableSetting.vue?vue&type=template&id=0dd25f83&lang=pug"
import script from "./tableSetting.vue?vue&type=script&lang=js"
export * from "./tableSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports